import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class LoadingSpinner extends React.Component {
  render () {
    const classes = classNames({
      "loading-spinner": true,
      "hidden": !this.props.show
    });

    const message = this.props.message || "Loading";

    return (
      <div className={classes}>
        <div className="message">
          {message} <i className="fa fa-spinner fa-pulse"></i>
        </div>
      </div>
    );
  }
}

LoadingSpinner.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string
};

export default LoadingSpinner;
